import gql from "graphql-tag";
import { SearchContext } from "@/shared/search/search.types";
import { generateContentNodeFragments } from "@/abilities/documentation/helpers/documentation.ts";

export const generateSearchDocumentsQuery = (
    dataFieldsFragment: Record<string, string[]>,
    localizationDatafieldsFragment: Record<string, string[]>,
    fields: Record<string, string>,
    context?: SearchContext
) => {
    const { contentMapFragment, topicFragment, acceptedLanguageParam } = generateContentNodeFragments(
        dataFieldsFragment,
        localizationDatafieldsFragment,
        fields
    );

    const contentsFragment = `contents(first: $first, after: $after, sort: $sort) {
        cursor
        highlights {
            title(length: 256)
            text(length: 256)
        }
        node {
            id
            contentId
            locale
            useContext {                
                custom_products
                rootContentMap {
                    teasers {
                        title(length: 256)
                    }
                    versionLabel
                }
            } 
            ${contentMapFragment}
            ${topicFragment}
        }
    }`;

    if (context?.mechanic) {
        return gql`query searchRelatedContentsMechanic($mechanicId: String!,$first: NonNegativeInt, $after: String, $contentFilter: ContentFilter, $sort: [ContentSort] ${acceptedLanguageParam} ) {
            mechanic(id: $mechanicId) {
                id
                relatedContents(filter: $contentFilter) {
                    total(trackLimit: 500) {
                        count
                        countRelation
                    }
                    ${contentsFragment}
                }
            }
        }`;
    }

    if (context?.asset && context?.product)
        return gql` query searchDocumentsForAssetWithProduct($assetFilter: AssetFilter!, $contentFilter: ContentFilter!, $first: NonNegativeInt, $after: String, $sort: [ContentSort] ${acceptedLanguageParam} ) {
            assets(filter: $assetFilter) {
                assets(first:1) {
                    cursor
                    node {
                        id
                        relatedContents(filter: $contentFilter) {
                            total(trackLimit: 500) {
                                count
                                countRelation
                            }
                            ${contentsFragment}
                        }
                    }
                }
            }
        } `;

    if (context?.product)
        return gql`query searchRelatedContentsProduct($productId: String!,$first: NonNegativeInt, $after: String, $contentFilter: ContentFilter, $sort: [ContentSort] ${acceptedLanguageParam} ) {
            product(id: $productId) {
                id
                relatedContents(filter: $contentFilter) {
                    total(trackLimit: 500) {
                        count
                        countRelation
                    }
                    ${contentsFragment}
                }
            }
        }`;

    if (context?.article)
        return gql`query relatedContentsForArticle($articleId: String!, $first: NonNegativeInt, $after: String,$contentFilter: ContentFilter, $sort: [ContentSort] ${acceptedLanguageParam} )  {
            article(id: $articleId) {
                id
                relatedContents(filter: $contentFilter) {
                    total(trackLimit: 500) {
                        count
                        countRelation
                    }
                    ${contentsFragment}
                }
            }    
        }`;

    return gql`
        query searchDocuments($first: NonNegativeInt, $after: String, $contentFilter: ContentFilter, $sort: [ContentSort] ${acceptedLanguageParam} )  {
            contents(filter: $contentFilter) {
                total(trackLimit: 500) {
                    count
                    countRelation
                }
                ${contentsFragment}
            }
        }
    `;
};
